import DashboardView from "../../components/dashboard/DashboardView";

export function DashboardPage({
  agents,
  context,
  loadingReports,
  reportData,
  reportDraftFilters,
  roleScope,
  onFiltersChange,
  onReportFilterReset,
  onSyncNow,
}) {
  return (
    <DashboardView
      agents={agents}
      context={context}
      loading={loadingReports}
      onFiltersChange={onFiltersChange}
      onReportFilterReset={onReportFilterReset}
      onSyncNow={onSyncNow}
      reportData={reportData}
      reportDraftFilters={reportDraftFilters}
      roleScope={roleScope}
    />
  );
}

export default DashboardPage;
